import { ApolloClient, NormalizedCacheObject, useQuery } from '@apollo/client'
import { UserReviewsQuery, UserReviewsQueryVariables } from 'types/graphql'
import { userReviewsQuery } from './userReviews.graphql'

export const preloadUserReviews = ({
  apolloClient,
  variables
}: {
  apolloClient: ApolloClient<NormalizedCacheObject>
  variables?: UserReviewsQueryVariables
}) => {
  return apolloClient.query({
    query: userReviewsQuery,
    variables
  })
}

export const useUserReviews = (variables?: UserReviewsQueryVariables) =>
  useQuery<UserReviewsQuery, UserReviewsQueryVariables>(userReviewsQuery, {
    variables
  })
